
  <div class="loading-container" style="padding-top:10%"  *ngIf="!loading">
      <ion-spinner></ion-spinner>
  </div>
<div class="email-form">
  <div class="form-group">
    <label for="to">To:</label>
    <input id="to" type="email" [(ngModel)]="to" placeholder="Recipient email" />
  </div>
  
  <div class="form-group">
    <label for="subject">Subject:</label>
    <input id="subject" type="text" [(ngModel)]="subject" placeholder="Email subject" />
  </div>

  <div class="form-group">
    <label for="body">Details:</label>
    <textarea id="body" rows="5" [(ngModel)]="body" placeholder="Enter email body here..."></textarea>
  </div>
<ion-button  (click)="openOutlook()" color="gallaghergreen">Open Outlook</ion-button>
   <ion-button  style="margin-left:20px"  color="gallaghergreen" (click)="sendEmail()">Send Email</ion-button>
</div>
